export default "__VITE_ASSET__DjfzWIif__"